import React, { useState } from "react";
import {
  makeStyles,
  Grid,
  Typography,
  IconButton,
  Button,
  Modal,
  FormHelperText,
  CircularProgress,
  Dialog,
} from "@material-ui/core";
import UnioButton from "./button";
import {
  CircleArrowFowardIcon,
  CircleArrowDownIcon,
  StatusInfoIcon,
  PlainIcon,
  CloseIcon,
  SuccessIcon,
} from "../icons";
import { formatDate, FormValidator } from "../helpers";
import { StyledInput } from "./text-field";
import { patientsServices } from "../services";
import { useContext } from "react";
import { AuthContext } from "../context";
import { useEffect } from "react";

const ResendEmailModal = ({ open, onClose, assigment }) => {
  const classes = makeStyles((theme) => ({
    button: {
      backgroundColor: "#FFF",
      fontSize: "1rem",
      height: 37,
      width: "8rem",
      borderRadius: 16,
      color: theme.palette.secondary.main,
      border: `1px solid ${theme.palette.secondary.main}`,
      boxSizing: "border-box",
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
        color: "#FFF",
      },
    },
    paperModal: {
      position: "relative",
      width: "90%",
      top: "unset",
      bottom: "unset",
      left: "unset",
      right: "unset",
      overflowY: "scroll",
      height: "50%",
      backgroundColor: "#FFF",
      boxShadow: theme.shadows[5],
      borderRadius: "45px",
      padding: "12px",
      outline: "none",
      [theme.breakpoints.up("md")]: {
        width: "40%",
      },
      "&::-webkit-scrollbar": {
        width: "1px",
        height: "8px",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0,0,0,.1)",
        borderRadius: "10px",
      },
    },
  }))();

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(assigment.email || "N/A");
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  useEffect(() => {
    setEmail(assigment.email);
    setErrors({});

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const validator = new FormValidator([
    {
      field: "email",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese correo electronico.",
    },
    {
      field: "email",
      method: "isEmail",
      validWhen: true,
      message: "Ingrese un correo electronico valido.",
    },
  ]);
  const onBlur = async (field, value) => {
    let validate = validator.validateField(field, value);
    let aux = { ...errors };
    aux[field] = validate[field];
    setErrors(aux);
  };
  const { authState, signOut } = useContext(AuthContext);
  const onSubmit = async () => {
    const validation = validator.validate({
      email,
    });
    setErrors(validation);
    if (validation.isValid) {
      try {
        setLoading(true);
        const response = await patientsServices.reAssignProduct({
          data: {
            email,
            id: assigment._id,
          },
          token: authState.user.token,
        });

        if (response.error) {
          alert(response.error.message);
        } else if (response.status === 401) {
          signOut();
        }

        setSuccessMessage("Correo reenviado exitosamente");
        // setTimeout(() => setSuccessMessage(""), 3000);
      } catch (error) {
        setLoading(false);

        alert("error desconocido");
      } finally {
        setLoading(false);
      }
    }
  };

  if (successMessage) {
    return (
      <Dialog
        open={successMessage}
        onClose={() => {
          setSuccessMessage("");
          onClose();
        }}
        style={{ borderRadius: "8rem" }}
        PaperProps={{
          style: {
            borderRadius: "2rem",
          },
        }}
      >
        <Grid
          container
          display="flex"
          direction="column"
          alignItems="center"
          justifty="center"
          style={{ padding: "2rem 1rem", height: "16rem" }}
        >
          <Grid item>
            <SuccessIcon />
          </Grid>
          <Grid item style={{ margin: "auto 0" }}>
            <Typography
              style={{ fontWeight: "bold", fontSize: "1rem" }}
              align="center"
              color="primary"
            >
              Correo reenviado exitosamente
            </Typography>
          </Grid>
          <Grid item>
            <UnioButton
              fullWidth
              onClick={() => {
                setSuccessMessage("");
                onClose();
              }}
            >
              ACEPTAR
            </UnioButton>
          </Grid>
        </Grid>
      </Dialog>
    );
  }

  return (
    <>
      <Modal
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          marginTop: "auto",
        }}
        open={open}
        disableBackdropClick
      >
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="center"
          item
          className={classes.paperModal}
        >
          <IconButton
            style={{ position: "absolute", right: "1rem" }}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
          <Grid
            container
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid
              item
              container
              justify="center"
              alignItems="center"
              style={{ margin: "43px 0 30px 0" }}
            >
              <PlainIcon />
            </Grid>
            <Grid
              className={classes.closeSesion}
              justify="center"
              direction="column"
              alignItems="center"
            >
              <StyledInput
                disabled={loading}
                onBlur={() => onBlur("email", email)}
                error={errors.email && errors.email.isInvalid}
                style={{ width: "12rem", marginTop: "auto" }}
                value={email}
                onChange={(e) =>
                  e.target.value.length < 32 && setEmail(e.target.value)
                }
                disableUnderline
              />
              <FormHelperText error={errors.email && errors.email.isInvalid}>
                {errors.email ? errors.email.message : " "}
              </FormHelperText>
            </Grid>
            <Grid
              container
              display="flex"
              direction="column"
              justify="center"
              alignItems="center"
              item
              style={{ margin: "auto 0 4rem 0" }}
            >
              <Button
                disabled={loading}
                className={classes.button}
                fullWidth
                // onClick={() => setSuccessMessage(" ")}
                onClick={() => onSubmit()}
              >
                {loading ? (
                  <CircularProgress color="#2196C0" size={24} />
                ) : (
                  "REENVIAR"
                )}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};
export default function AssignCard(props) {
  const { isOrder, order, assigment, onClickStatus, open, openCard, index } =
    props;
  const classes = useStyles({
    status: !isOrder ? assigment.status : order.status,
    ...props,
  })();
  const [openResendEmailModal, setOpenResendEmailModal] = useState(false);

  return (
    <>
      <Grid container className={classes.box} xs={12} md={12}>
        <Grid item container className={classes.item}>
          <Grid
            className={classes.item}
            style={{ width: "6rem" }}
            item
            container
            justify="space-between"
            alignItems="flex-start"
            direction="column"
            onClick={() => openCard()}
          >
            <Typography color="secondary">
              {!isOrder ? "Paciente" : "Laboratorio"}
            </Typography>
            <Typography color="primary">
              {!isOrder
                ? `${assigment.firstName} ${assigment.lastName} `
                : order.laboratory.name}
            </Typography>
          </Grid>

          {!isOrder && assigment.status === 0 && (
            <Grid
              className={classes.item}
              style={{ margin: "0 6px 0 auto" }}
              item
            >
              <ResendEmailModal
                assigment={assigment}
                open={openResendEmailModal}
                onClose={() => setOpenResendEmailModal(false)}
              />
              <Button
                onClick={() => setOpenResendEmailModal(true)}
                className={classes.button}
                style={{ margin: "auto 0", minWidth: "10rem" }}
              >
                Reenviar Correo
              </Button>
            </Grid>
          )}
          <Grid
            className={classes.item}
            item
            style={{ width: "10rem" }}
            container
          >
            <Grid
              className={classes.status}
              item
              container
              style={{ cursor: "pointer", width: "6rem" }}
              justify="space-between"
              alignItems="center"
              onClick={onClickStatus}
            >
              {
                <StatusInfoIcon
                  color={
                    !isOrder
                      ? assigment.status === "6618298e7b4df03548c403ff"
                        ? "#FF1531" // Paciente repetido
                        : assigment.status === "661829ad7b4df03548c40400"
                        ? "#FF619A" // Entrega fallida
                        : assigment.status === "661829c97b4df03548c40401"
                        ? "#FF619A" // No aceptada por el paciente
                        : assigment.status === "661829e67b4df03548c40402"
                        ? "#007bff" // En preparación
                        : assigment.status === "66182a037b4df03548c40403" ||
                          assigment.status === 3
                        ? "#22D3C5" // En reparto
                        : assigment.status === "66182a197b4df03548c40404" ||
                          assigment.status === 0
                        ? "#F28C22" // En espera por aprobación del paciente
                        : assigment.status === "66182a497b4df03548c40405" ||
                          assigment.status === 1
                        ? "#12FF77" // Entregado
                        : assigment.status === "66182a677b4df03548c40406"
                        ? "#FF619A" // No respondido por el paciente
                        : assigment.status === "66182a7e7b4df03548c40407"
                        ? "#FF619A" // No recibido por el paciente
                        : "#FF1531" // Rechazada por el paciente
                      : order.status === 0 ||
                        order.status === "66182a197b4df03548c40404"
                      ? "#F28C22" // En espera
                      : order.status === 1 ||
                        order.status === "66182a497b4df03548c40405"
                      ? "#22D3C5" // Entregado
                      : "#FF619A" // Fallida
                  }
                />
              }
              <Typography>
                {!isOrder
                  ? assigment.status === "6618298e7b4df03548c403ff"
                    ? "Paciente repetido"
                    : assigment.status === "661829ad7b4df03548c40400"
                    ? "Entrega fallida"
                    : assigment.status === "661829c97b4df03548c40401"
                    ? "No aceptada por el paciente"
                    : assigment.status === "661829e67b4df03548c40402"
                    ? "En preparación"
                    : assigment.status === "66182a037b4df03548c40403" ||
                      assigment.status === 3
                    ? "En reparto"
                    : assigment.status === "66182a197b4df03548c40404" ||
                      assigment.status === 0
                    ? "En espera por aprobación del paciente"
                    : assigment.status === "66182a497b4df03548c40405" ||
                      assigment.status === 1
                    ? "Entregado"
                    : assigment.status === "66182a677b4df03548c40406"
                    ? "No respondido por el paciente"
                    : assigment.status === "66182a7e7b4df03548c40407"
                    ? "No recibido por el paciente"
                    : "Rechazada por el paciente"
                  : order.status === 0 ||
                    order.status === "66182a197b4df03548c40404"
                  ? "En espera"
                  : order.status === 1 ||
                    order.status === "66182a497b4df03548c40405"
                  ? "Entregado"
                  : "Fallida"}
              </Typography>
            </Grid>
            <Grid
              item
              justify="space-between"
              alignItems="center"
              onClick={() => openCard()}
            >
              <IconButton>
                {open !== index ? (
                  <CircleArrowFowardIcon />
                ) : (
                  <CircleArrowDownIcon />
                )}
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
        {open === index && (
          <>
            <Grid
              className={classes.item}
              xs={isOrder ? 12 : 6}
              md={3}
              container
              justify="space-between"
              alignItems="flex-start"
              direction="column"
            >
              <Typography color="secondary">
                {!isOrder ? "Rut" : "Medicamento"}
              </Typography>
              <Typography
                color="primary"
                style={{ textTransform: "uppercase" }}
              >
                {!isOrder ? assigment.rut : order.product.name}
              </Typography>
            </Grid>
            {!isOrder && (
              <Grid
                className={classes.item}
                item
                xs={6}
                md={3}
                direction="column"
                container
                justify="space-between"
                alignItems="flex-start"
                style={{
                  height: assigment.products.length > 1 ? "fit-content" : 40,
                }}
              >
                <Typography color="secondary">Medicamentos</Typography>
                {assigment.products.map((medicine, index) => (
                  <Typography
                    color="primary"
                    key={index}
                    style={{
                      margin:
                        !index && assigment.products.length > 1 ? "5px 0" : 0,
                      textTransform: "uppercase",
                    }}
                  >
                    {medicine.name}
                  </Typography>
                ))}
              </Grid>
            )}
            <Grid
              className={classes.item}
              item
              xs={6}
              md={3}
              container
              justify="space-between"
              alignItems="flex-start"
              direction="column"
            >
              <Typography color="secondary">Fecha de envio</Typography>
              <Typography color="primary">
                {formatDate(
                  new Date(!isOrder ? assigment.createdAt : order.createdAt)
                )}
              </Typography>
            </Grid>
            <Grid
              className={classes.item}
              item
              xs={6}
              md={3}
              container
              justify="space-between"
              alignItems="flex-start"
              direction="column"
            >
              <Typography color="secondary">{`Fecha de ${
                !isOrder
                  ? assigment.status === 2
                    ? "rechazo "
                    : "aprobación"
                  : order.status === 2
                  ? "rechazo"
                  : "aprobación"
              }`}</Typography>
              {!isOrder && assigment.updatedAt ? (
                <Typography color="primary">
                  {formatDate(new Date(assigment.updatedAt))}
                </Typography>
              ) : isOrder && order.updatedAt ? (
                <Typography color="primary">
                  {formatDate(new Date(order.updatedAt))}
                </Typography>
              ) : (
                <Typography color="primary">Pendiente</Typography>
              )}
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
}

const useStyles = ({ status, ...props }) =>
  makeStyles((theme) => ({
    box: {
      background: "#FFFFFF",
      boxShadow: "0px 4px 10px rgba(198, 198, 198, 0.5)",
      borderRadius: 22,
      width: "100%",
      height: "fit-content",
      padding: 13,
    },
    status: {
      fontSize: "1rem",
      lineHeight: "1.25rem",
      fontWeight: "500",
      color:
        status === "6618298e7b4df03548c403ff"
          ? "#FF1531" // Paciente repetido
          : status === "661829ad7b4df03548c40400"
          ? "#FF619A" // Entrega fallida
          : status === "661829c97b4df03548c40401"
          ? "#FF619A" // No aceptada por el paciente
          : status === "661829e67b4df03548c40402"
          ? "#007bff" // En preparación
          : status === "66182a037b4df03548c40403" || status === 3
          ? "#22D3C5" // En reparto
          : status === "66182a197b4df03548c40404" || status === 0
          ? "#F28C22" // En espera por aprobación del paciente
          : status === "66182a497b4df03548c40405" || status === 1
          ? "#12FF77" // Entregado
          : status === "66182a677b4df03548c40406"
          ? "#FF619A" // No respondido por el paciente
          : status === "66182a7e7b4df03548c40407"
          ? "#FF619A" // No recibido por el paciente
          : "#FF1531", // Rechazada por el paciente
    },
    item: {
      margin: "5px 0",
      minHeight: 40,
      display: "flex",
      "flex-direciont": "row",
      "justify-content": "space-between",
      "& p:nth-child(1)": {
        fontSize: "0.813rem",
        lineHeight: "1rem",
        fontWeight: "500",
      },
      "& p": {
        fontSize: "0.875rem",
        lineHeight: "1.063rem",
        fontWeight: "500",
      },
    },
    button: {
      backgroundColor: true ? "#FFF" : theme.palette.secondary.main,
      fontSize: "0.875rem",
      lineHeight: "1.063rem",
      height: 37,
      borderRadius: 16,
      color: true ? theme.palette.secondary.main : "#FFF",
      border: true ? `1px solid ${theme.palette.secondary.main}` : "unset",
      boxSizing: "border-box",
      "&:hover": {
        backgroundColor: true ? "#FFF" : theme.palette.secondary.main,
      },
    },
  }));
